import React, { FC } from 'react';
import { Box, Grid, GridSize, TextFieldProps } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import FormikValidationError from '../FormikErrors';
import TextField from '@mui/material/TextField';
import styled from '@mui/system/styled';

type ITextInput = TextFieldProps & {
  label: string;
  formik?: any;
  required?: boolean;
  disableRequiredValidation?: boolean;
  onIconClick?: () => void;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  readOnly?: boolean;
  /** Responsive column widths of the wrapping Grid item. */
  xs?: GridSize;
  sm?: GridSize;
  md?: GridSize;
  lg?: GridSize;
};

export const Input = styled(TextField)(({ theme }) => ({
  marginBottom: 24,
  input: {
    backgroundColor: 'white'
  },
  svg: {
    cursor: 'pointer'
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0
  }
}));

const TextInput: FC<ITextInput> = ({
  label,
  formik,
  required,
  onIconClick,
  startIcon,
  endIcon,
  readOnly,
  xs = 12,
  sm = 12,
  md = 4,
  lg,
  ...props
}) => {
  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg} style={{ width: '100%' }}>
      <Box sx={{ mb: 3 }}>
        <Input
          {...props}
          InputLabelProps={{
            shrink: true,
            style: {
              fontSize: 15
            }
          }}
          InputProps={{
            ...props.InputProps,
            startAdornment: startIcon && (
              <InputAdornment onClick={onIconClick} position="start">
                {startIcon}
              </InputAdornment>
            ),
            endAdornment: endIcon && (
              <InputAdornment onClick={onIconClick} position="end">
                {endIcon}
              </InputAdornment>
            )
          }}
          label={label}
          variant="outlined"
          fullWidth
          size="small"
          required={required}
          sx={{ mb: 0.5 }}
          value={props.value ?? ''}
          disabled={readOnly}
        />

        <FormikValidationError
          name={props.name ?? ''}
          errors={formik.errors}
          touched={formik.touched}
        />
      </Box>
    </Grid>
  );
};

export default TextInput;
